import Reward from '../../../baseComponents/gui/reward/Reward';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import useTimer from '../../../../hooks/useTimer';
import { useToDaysLongHoursLongOrHHMMSS } from '../../../../hooks/shared/time/useToDaysLongHoursLongOrHHMMSS';

export default function BuffItem({ buffData }) {
  const { reward, title, from, until, elapsed } = buffData;

  const [time, { start }] = useTimer(elapsed * 1000);

  const progress = elapsed / (until - from);

  const toDaysLongHoursLongOrHHMMSS = useToDaysLongHoursLongOrHHMMSS();

  useEffect(() => {
    elapsed > 0 && start();
  }, [elapsed]);

  return (
    <div className={`friends-buffs__item`}>
      <div className={'friends-buffs__item-reward'}>
        <Reward {...reward} mod={'challenge'} />
      </div>

      <div className={'friends-buffs__item-info'}>
        <h2
          className={classNames('friends-buffs__item-title', {
            'friends-buffs__item-title_min': title.length > 25,
          })}
        >
          {title}
        </h2>

        <div className={'friends-buffs__item-progress'}>
          <div className={'friends-buffs__item-progress-line'} style={{ transform: `translateX(-${progress}%)` }} />

          {time > 0 && (
            <div
              className={classNames(`friends-buffs__item-progress-time`, {
                [`friends-buffs__item-progress-time_min`]:
                  toDaysLongHoursLongOrHHMMSS({ milliseconds: time }).length > 9,
              })}
            >
              {toDaysLongHoursLongOrHHMMSS({ milliseconds: time })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
